<div class="ag-individual-relationship-actions d-flex align-items-center">
  <a [routerLink]="entityLink()">
    <app-ag-action-icon-button [iconClass]="entityIcon()"/>
  </a>

  @if(showActionMenu()) {
  <div
    ngbDropdown
    class="dropdown d-inline-flex"
    container="body"
    [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
  >
    <app-ag-action-icon-button ngbDropdownToggle iconClass="ic-more-horizontal-16"/>

    <div ngbDropdownMenu class="dropdown-menu common-dropdown-menu">
      <div
        ngbDropdownItem
        class="dropdown-item"
        (click)="onUpdateContactDetails()"
      >
        <i class="icon ic-refresh-20"></i>
        <span class="title">Update Contact Details</span>
      </div>


        <div class="dropdown-section-header">
          Split Individuals
        </div>

      <div
        ngbDropdownItem
        class="dropdown-item"
        (click)="splitIndividualsToNew()"
      >
        <i class="icon ic-split-to-new-20"></i>
        <span class="title">Split to New</span>
      </div>

      <div
        ngbDropdownItem
        class="dropdown-item"
        (click)="onAssignIndividualsToExisting()"
      >
        <i class="icon ic-assign-to-existing-20"></i>
        <span class="title">Assign to Existing</span>
      </div>

        @if (isCompany()) {
          <div class="dropdown-section-header">
            Forms
          </div>

        <div
          ngbDropdownItem
          class="dropdown-item document-dropdown-item"
          (click)="onChangeName()"
        >
          <i class="icon ic-change-officer-name-20"></i>
          <div>
            <div class="title">Change Name</div>
            <div class="asic-form">Form 484A2</div>
          </div>
        </div>

        <div
          ngbDropdownItem
          class="dropdown-item document-dropdown-item"
          (click)="onChangeAddress()"
        >
          <i class="icon ic-change-address-20"></i>
          <div>
            <div class="title">Change Address</div>
            <div class="asic-form">Form 484A1</div>
          </div>
        </div>

        <div
          ngbDropdownItem
          class="dropdown-item document-dropdown-item"
          (click)="onMistakeCorrection()"
        >
          <i class="icon ic-request-for-corrections-20"></i>
          <div>
            <div class="title">Mistake Correction</div>
            <div class="asic-form">Form 492</div>
          </div>
        </div>
      }
      </div>
    </div>
  }

</div>
